import React, { useState } from 'react'
import styled from 'styled-components'
import {
  breakpoints,
  colours,
  fonts
} from '../../styles/global.styles'

const SelectedOrderColours = [
  colours.pink,
  colours.lightpink
]

const MultipleSelectWrapper = styled.div`
  
  @media screen and (min-width: ${breakpoints.sm + 1}px) {
    height: 200px;
    column: 2;
    display:flex;
    flex-direction:column;
    flex-wrap:wrap;
  }
`;

const OptionItem = styled.label`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin-bottom: 12px;
  pointer-events: ${props => props.disabled ? 'none':'all'};
  opacity: ${props => props.disabled ? '.5':'1'};
  cursor: pointer;

  input[type="checkbox"] {
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
  }

  span.indicator-wrapper {
    height: 36px;
    width: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 3px;
    position: relative;

    &:after {
      position: absolute;
      content: '';
      visibility: hidden;
      background-color: ${colours.pink_alpha40};
      height: 36px;
      width: 36px;
      border-radius: 50%;
    }

    span.indicator {
      height: 24px;
      width: 24px;
      border-radius: 50%;
      border:2px solid ${colours.grey2};
      display: flex;
      justify-content: center;
      align-items: center;

      &:before {
        content: '';
        display: inline-block;
        background-color: ${colours.pink};
        height: 14px;
        width: 14px;
        left: 11px;
        top: 11px;
        border-radius: 50%;
        visibility: hidden;
      }
    }
  }

  input[type="checkbox"]:checked + span.indicator-wrapper > span.indicator {
    border-color: ${props => SelectedOrderColours[props.selectedOrder] ?? SelectedOrderColours[SelectedOrderColours.length - 1]};
    &:before {
      visibility: visible;
      background-color: ${props => SelectedOrderColours[props.selectedOrder] ?? SelectedOrderColours[SelectedOrderColours.length - 1]};
    }
  }

  
  &:hover {
    span.indicator-wrapper {
      &:after {
        visibility: visible;
      }
    }
  }


  span.label {
    color: ${colours.darkergrey2};
    font-family: ${fonts.content.regular};
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;

    b {
      font-family: ${fonts.content.bold};
    }
  }

  @media screen and (min-width: ${breakpoints.sm + 1}px) {
    width:50%;
    margin-bottom: 3.6px;
  }
`;

export default function MultipleSelect({
  name,
  onChange,
  options = [],
  selected = [],
  maxSelectable = -1
}) {
  const [selectedOptions, setSelectedOptions] = useState(selected)
console.log(selectedOptions)
  return (
    <MultipleSelectWrapper className="multiple-select">
      {options.map((option, i) => (
        <OptionItem 
          className="option-item"
          key={i}
          selectedOrder={selectedOptions.findIndex(item => item === option.value)}
          disabled={(!selectedOptions.includes(option.value) && selectedOptions.length === maxSelectable)}
        >
          <input 
            name={name}
            type="checkbox" 
            value={option.value}
            defaultChecked={selected.includes(option.value)}
            onChange={(evt) => {
              let updatedSelect = [];
              if (evt.target.checked) {
                updatedSelect = [
                  ...selectedOptions,
                  option.value
                ]
              } else {
                const existingIndex = selectedOptions.findIndex(item => item === option.value);
                if (existingIndex !== -1) {
                  updatedSelect = [...selectedOptions]
                  updatedSelect.splice(existingIndex, 1)
                }
              }
              setSelectedOptions(updatedSelect)
              onChange && onChange(updatedSelect)
            }}
          />
          <span className="indicator-wrapper">
            <span className="indicator"></span>
          </span>
          <span className="label" dangerouslySetInnerHTML={{
            __html: option.name
          }}>
          </span>
        </OptionItem>
      ))}
    </MultipleSelectWrapper>
  );
}